export function getFaProvince(province) {
  switch (province) {
    case "hamedan":
      return "همدان";
    case "markazi":
      return "مركزی";
    case "lorestan":
      return "لرستان";
    default:
      return "نامشخص";
  }
}
